import './components/*';

import { format } from 'date-fns';

const $events = $('.js-event');

const currentTime = format(new Date(), 'yyyyMMddHHmm');

console.log(`Current time: ${currentTime}`);

function updateEventStatus(currentTime) {
  $events.each((index, event) => {
    const $event = $(event);
    const [eventStartTime, eventFinishTime] = $event.data('time');
    if (Number(currentTime) > Number(eventFinishTime)) {
      $event.addClass('is-complete');
    }
    if (
      Number(currentTime) >= Number(eventStartTime) &&
      Number(currentTime) <= Number(eventFinishTime)
    ) {
      $event.addClass('is-active');
    }
  });
}

updateEventStatus(currentTime);

window.updateEventStatus = updateEventStatus;
